// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gzpj","right":"styles_right__2xoat"};